export const PRIZE_TOKEN_TEST: { [key: string]: string } = {
  ETH: '0x7be7937A395FD3B527F428124f6a33E10D1C0638',
  USDC: '0xf0380c236Eb7C3Fc51a9b46706D27bA738B0BE7f',
};
